import { render } from "./commerce-connector.vue?vue&type=template&id=7c5ee4f0"
import script from "./commerce-connector.vue?vue&type=script&lang=js"
export * from "./commerce-connector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__